export default "__VITE_ASSET__BSpUrvmS__ 1200w";